var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedVclara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.762,
    height: 19.943,
    viewBox: "0 0 21.762 19.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(255,255,255)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2.5,
    d: "M15.88078764 5.88078764l-5.71428572 8.18181818-4.28571428-4.67532468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedVclara);
export default __webpack_public_path__ + "static/media/checked_vclara.3d26fb61d32e47429ed3e48be4315c6e.svg";
export { ForwardRef as ReactComponent };